import {
  Component,
  computed,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';

import {
  CdkMenu,
  CdkMenuBar,
  CdkMenuItem,
  CdkMenuTrigger,
} from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '@services/auth.service';
import { UserBreakService } from '@services/user-break.servise';
import { UserRole } from 'src/app/enums/user-role';
import { TranslateModule } from '@ngx-translate/core';
import { ParseBase64Pipe } from '../../../../pipes/parse-base64.pipe';
import { MapToColorClassPipe } from '../../../../pipes/map-to-color-class.pipe';
import { HasRoleDirective } from '../../../../directives/has-role.directive';
import packageInfo from '../../../../../../package.json';
import { IconsImageComponent } from '../../icons-image/icons-image.component';
import { environment } from 'src/environments/environment';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'app-profile-cabinet',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatDividerModule,
    MatButtonModule,
    CdkMenuTrigger,
    CdkMenuItem,
    CdkMenu,
    CdkMenuItem,
    MatIconModule,
    TranslateModule,
    CdkMenuBar,
    ParseBase64Pipe,
    MapToColorClassPipe,
    HasRoleDirective,
    IconsImageComponent,
  ],
  templateUrl: './profile-cabinet.component.html',
  styleUrl: './profile-cabinet.component.scss',
})
export class ProfileCabinetComponent {
  @Output() onLogOut = new EventEmitter();
  staffBreaks = computed<{ label: string; time: number }[]>(
    () => this.authService.user().globalConfiguration!.staffBreaks,
  );
  checkedStatus = computed<string>(
    () => this.authService.user().availabilityStatus!,
  );

  private userBreakService = inject(UserBreakService);
  private authService = inject(AuthService);
  public version = environment.version;
  user = this.authService.user();
  departments = this.user.departments;
  role = UserRole;
  roles = [
    UserRole.NURSE,
    UserRole.CHARGE_NURSE,
    UserRole.DOCTOR,
    UserRole.HEALTH_CARE_ASSISTANT,
    UserRole.CARDIOLOGIST,
    UserRole.CLEANING_STAFF,
  ];

  roleWithoutAvatar(): boolean {
    const disallowedRoles = [
      UserRole.UNIT_ADMINISTRATOR,
      UserRole.LOCATING_OPERATOR,
      UserRole.PORTAL_ADMINISTRATOR,
      UserRole.SECURITY_MANAGER,
      UserRole.SECURITY_COMMAND_CENTRE,
    ];

    return disallowedRoles.includes(this.user.role);
  }

  getFirstLetters(): string {
    return this.user.inAppName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('');
  }

  updateUserStatus(status: string): void {
    this.userBreakService.sendUserUpdate(status);
  }

  handleLogOut() {
    this.onLogOut.emit();
  }

  menuPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'top',
      offsetY: 55,
    },
  ];
}
